<div class="dashboard-content-sec ">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

    <form (ngSubmit)="savePage()" [formGroup]="form">
        <div class="row form-section">
            <div class="col">
                <div class="card">
                    <app-breadcrumb [crumbList]="crumbList"></app-breadcrumb>

                    <div class="card-title">
                        <h5 class="fa fa-address-book">
                          {{ this.title }}
                        </h5>

                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="8">Submit</button>
                        </div>
                    </div>

                    <div class="card-form">
                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>

                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>

   
                        <div class="form-row">
                            <label class="col-sm-2" for="Order">Order</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="Order"  id="Order"
                                name="Order" type="text" 
                                required 
                                class="form-control" 
                                tabindex="1" placeholder="">
                            </div>
                        </div>    
                        <div *ngIf="OrderCtrl.invalid && (OrderCtrl.dirty || OrderCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="OrderCtrl.errors.required">
                                <span>Order is required.</span>
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2 control-label" for="Name">Page Name</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="Name"  id="Name"
                                    name="Name" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="2" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="NameCtrl.invalid && (NameCtrl.dirty || NameCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="NameCtrl.errors.required">
                              <span>Page Name is required.</span>
                           </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </form>
            
    <div *ngIf="this.id > 0">
        <app-post-list [parent_id]="this.id" [parent_name]="form.value.Name"></app-post-list>
    </div>

</div>
